export class Sampler {
  static create(samplingRate = 0.05) {
    return new Sampler(samplingRate)
  }

  constructor(private samplingRate: number) {
    if (samplingRate < 0 || samplingRate > 1) {
      throw new Error('Sampling rate must be between 0 and 1')
    }
  }

  shouldSample(): boolean {
    return Math.random() < this.samplingRate
  }
}
